import { StructureAdvancedFilter } from '@/entities/structure/group';
import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { TBranchSchema } from '@/schemas/branch/branch.schema';
import { mapStructureFilterAPI } from '@/utils/map.utils';
import { ListAllBranch, TotalActiveBranch } from '../entities/branch';
import { TBranchUserSchema } from '@/schemas/branch-user/branch-user.schema';
import { TOKEN_API_PUBLIC } from '@/utils/constant.utils';

const BRANCH_URI = '/branch';

export const createNewBranch = async (
  branch: TBranchSchema,
  query?: TBranchUserSchema
) => {
  let url = `${BRANCH_URI}`;
  const params = new URLSearchParams();

  if (query?.createdByUserId) {
    params.append('createdByUserId', query?.createdByUserId);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.POST,
    body: branch,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getExistingBranch = async (query?: TBranchSchema) => {
  let url = `${BRANCH_URI}/existing`;
  const params = new URLSearchParams();

  if (query?.id) {
    params.append('id', query.id);
  }

  if (query?.name) {
    params.append('name', query.name);
  }

  if (query?.email) {
    params.append('email', query.email);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const listAllBranches = async (query?: ListAllBranch) => {
  let url = `${BRANCH_URI}/allBranches`;
  const params = new URLSearchParams();

  if (query?.userId) {
    params.append('userId', query.userId);
  }

  if (query?.distributorId) {
    params.append('distributorId', query.distributorId);
  }

  if (query?.groupId) {
    params.append('groupId', query.groupId);
  }

  if (query?.companyId) {
    params.append('companyId', query.companyId);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
      'x-api-token': TOKEN_API_PUBLIC,
    },
  });
};

export const getAllBranches = async (
  filter: StructureAdvancedFilter,
  page: number,
  limit: number,
  sortBy?: string,
  sortDirection?: 'asc' | 'desc'
) => {
  const filterMapped = mapStructureFilterAPI(filter);

  let url = `${BRANCH_URI}/all?${filterMapped}&page=${page}&limit=${limit}`;

  if (sortBy) {
    url += `&sortBy=${sortBy}&sortDirection=${sortDirection || 'asc'}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getTotalActiveBranches = async (query?: TotalActiveBranch) => {
  let url = `${BRANCH_URI}/totalActive`;
  const params = new URLSearchParams();

  if (query?.groupId) {
    params.append('groupId', query.groupId);
  }

  if (query?.companyId) {
    params.append('companyId', query.companyId);
  }

  if (query?.userId) {
    params.append('userId', query.userId);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getBranchById = async (id: string) => {
  return requestApi({
    url: `${BRANCH_URI}/${id}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getUnassignedBranchesToCompany = async (
  loggedInUserId?: string
) => {
  let url = `${BRANCH_URI}/unassignedBranchesToCompany`;
  const params = new URLSearchParams();

  if (loggedInUserId) {
    params.append('loggedInUserId', loggedInUserId);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAssignedBranchesToCompany = async (companyId: string) => {
  return requestApi({
    url: `${BRANCH_URI}/assigned/company/${companyId}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getUnassignedBranchesToUser = async (
  userId: string,
  loggedInUserId?: string
) => {
  let url = `${BRANCH_URI}/unassigned/user/${userId}`;
  const params = new URLSearchParams();

  if (loggedInUserId) {
    params.append('loggedInUserId', loggedInUserId);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAssignedBranchesToUser = async (
  userId: string,
  roleTypeId: string
) => {
  return requestApi({
    url: `${BRANCH_URI}/assigned/user/${userId}/role/${roleTypeId}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateBranch = async (branch: TBranchSchema) => {
  return requestApi({
    url: `${BRANCH_URI}/update`,
    method: HTTP_METHOD.PATCH,
    body: branch,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateManyBranches = async (branches: TBranchSchema[]) => {
  return requestApi({
    url: `${BRANCH_URI}/updateMany`,
    method: HTTP_METHOD.PATCH,
    body: branches,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const findByUser = async (userId: string, roleName: string) => {
  return requestApi({
    url: `${BRANCH_URI}/user/${userId}/role/${roleName}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
